import {
  IS_SYNERISE_CART_RECOMMENDATION_ENABLED,
  SYNERISE_CART_RECOMMENDATION_CAMPAIGN_ID,
  waitForSyneriseClientUUID
} from 'lib/synerise'
import {
  BaseRecommendationParams,
  getRecommendedProductsReturnType,
  getSyneriseRecommendedProductsByCampaign,
  ProductTypes,
  RecommendedProductsResponseTypes
} from 'modules/products'
import { isNotNilOrEmpty } from 'shared/utils/ramda'

import { getRecommendedProductsByCart } from '../../api'

interface CartRecommendationParams extends BaseRecommendationParams {
  cartId: string
}

const getCartRecommendedProductsFallback = async (
  cartId: string,
  token: string
) => {
  if (!cartId) return []

  try {
    const fallback: RecommendedProductsResponseTypes =
      await getRecommendedProductsByCart({ cartId, token })

    return fallback?.data?.data || []
  } catch (err) {
    console.error('Cart recommendations fallback failed', err)

    return []
  }
}

export const getRecommendedCartProducts = async ({
  cartId,
  token,
  distributionCenterId,
  syneriseRecommendationQueryParams
}: CartRecommendationParams): Promise<getRecommendedProductsReturnType> => {
  let syneriseRecommendedProducts: ProductTypes[] = []
  let correlationId: string | null = null

  if (IS_SYNERISE_CART_RECOMMENDATION_ENABLED) {
    // 1. Get Synerise client UUID if available
    syneriseRecommendationQueryParams.clientUUID =
      await waitForSyneriseClientUUID()

    // 2. Get Synerise recommendations if items (cart products) are present
    if (isNotNilOrEmpty(syneriseRecommendationQueryParams.itemId))
      ({ syneriseRecommendedProducts, correlationId } =
        await getSyneriseRecommendedProductsByCampaign(
          SYNERISE_CART_RECOMMENDATION_CAMPAIGN_ID,
          syneriseRecommendationQueryParams,
          distributionCenterId,
          token
        ))

    // 3. Check Synerise recommendations and return
    if (isNotNilOrEmpty(syneriseRecommendedProducts))
      return {
        recommendationProducts: syneriseRecommendedProducts,
        recommendationMetadata: {
          correlationId,
          campaignId: SYNERISE_CART_RECOMMENDATION_CAMPAIGN_ID
        }
      }
  }

  // 4. Get fallback from main API
  const fallbackRecommendedProducts = await getCartRecommendedProductsFallback(
    cartId,
    token
  )

  return {
    recommendationProducts: fallbackRecommendedProducts || [],
    recommendationMetadata: null
  }
}
